// extracted by mini-css-extract-plugin
export default {"what_i_do_container":"styles_what_i_do_container__MHliX","what_i_do_title":"styles_what_i_do_title__dtE-s","what_i_do_sub_container":"styles_what_i_do_sub_container__6edwb"};